import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";

function Appointment() {
  const calendlyRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Our Blog" },
    { to: "/get-in-touch", label: "Support" },
  ];

  useEffect(() => {
    // Load Calendly script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    // Measure header height
    const headerEl = document.getElementById("header");
    if (headerEl) {
      setHeaderHeight(headerEl.offsetHeight);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Book Your Discovery Call | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Header with higher z-index */}
      <div
        id="header"
        style={{
          position: "relative",
          zIndex: 10,
          backgroundColor: "#fff", // or your theme background
        }}
      >
        <Header links={navLinks} />
      </div>

      {/* Calendly embed below the header */}
      <div
        ref={calendlyRef}
        className="calendly-inline-widget pt-15" 
        data-url="https://calendly.com/viren-mydatapulse/discovery"
        style={{
          position: "relative",
          zIndex: 1,
          width: "100vw",
          height: `calc(100vh - ${headerHeight}px)`,
        }}
      ></div>
    </>
  );
}

export default Appointment;
